import styled from "styled-components";

export default styled.div`
  min-width: 310px;
  height: 980px;
  margin: 16px;
`;